import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import {environment} from '../../../../../../environments/environment';
import { IDocument, IHalitoResponse, IProfitCenter, IProfitCenterStatus } from './halito-model';

@Injectable()
export class HalitoService {

    constructor(private http: HttpClient) {
    }

    public checkProfitCenter(eventId: string): Observable<IProfitCenterStatus> {
        const url = `${environment.halitoApi.baseUrl}/invitedesk/invoice/profitcenter/event/${eventId}`;

        return this.http.get<IHalitoResponse<IProfitCenter>>(url).pipe(
            map(response => response.data),
            map((profitCenter: IProfitCenter) => ({
                exists: true,
                paydesk: profitCenter.invoicebook.invoicebookname,
                active: this.isProfitCenterConfigured( profitCenter),
                allowAutoCredit: profitCenter.allow_auto_credit,
                allowAutoRefund: profitCenter.allow_auto_refund,
                testMode: profitCenter.test_mode,
                onlinePayments: profitCenter.invoicebook.payment_method_online,
                offlinePayments: profitCenter.invoicebook.payment_method_offline,
                liveCredentialsValid: profitCenter.live_valid,
                testCredentialsValid: profitCenter.test_valid,
            })),
            catchError(() => of({
                exists: false,
                active: false,
                allowAutoCredit: false,
                allowAutoRefund: false,
                paydesk: '',
                testMode: false,
                onlinePayments: false,
                offlinePayments: false,
                liveCredentialsValid: false,
                testCredentialsValid: false,
            }))
        );
    }

    public fetchOrderDocuments(eventId: string, orderId: string): Observable<IDocument[]> {
        const url = `${environment.halitoApi.baseUrl}/invitedesk/invoice/documents?filter[order_id]=${orderId}`;
        return this.http
            .get<IHalitoResponse<IDocument[]>>(url)
            .pipe(
                map(response => response.data),
                catchError(() => of([])),
            );
    }

    public downloadDocument(document: IDocument, type: 'pdf' | 'ubl'): Observable<Blob|null> {
        const url = `${environment.halitoApi.baseUrl}/invitedesk/invoice/invoicebooks/${document.paydesk.id}/documents/${document.id}/download/${type}`;
        return this.http
            .get(url, { responseType: 'blob' })
            .pipe(
                map(content => new Blob([content], { type: type === 'pdf' ? 'application/pdf' : 'application/xml'})),
                catchError(() => of(null)),
            );
    }

    private isProfitCenterConfigured(profitCenter?: IProfitCenter): boolean {
        const paydesk = profitCenter?.invoicebook;
        if (!paydesk || profitCenter?.test_mode) {
            return false;
        }
        if(paydesk.payment_method_online) {
            return profitCenter.live_valid;
        }
        return paydesk.payment_method_offline;
    }
}
